import { Component } from "solid-js";

interface TravelAndTransportIconProps {
  class?: string;
}

export const TravelAndTransportIcon: Component<TravelAndTransportIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.9332 8.8L22.5332 13.2L24.9332 25.0667C25.0666 25.4667 24.9332 26 24.5332 26.2667L23.5999 27.2C22.9332 27.8667 21.7332 27.6 21.4666 26.8L17.9999 17.8667L13.4666 22.4L13.7332 25.3333C13.7332 25.7333 13.5999 26.1333 13.3332 26.4L11.8666 27.8667L9.06657 23.2L4.3999 20.4L5.73324 18.6667C5.9999 18.4 6.3999 18.2667 6.7999 18.2667L9.73324 18.5333L14.2666 14L5.1999 10.5333C4.3999 10.1333 4.13324 9.06666 4.7999 8.4L5.73324 7.46666C5.9999 7.2 6.53324 7.06666 6.93324 7.06666L18.7999 9.46666L23.1999 5.06666C24.2666 4 25.8666 4 26.9332 5.06666V5.06666C27.9999 6.13333 27.9999 7.73333 26.9332 8.8V8.8Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
